import './VenueClubDetailsPage.css';
import './PartyPackageDetailPage.css';
import HeroSectionBox from './custom-comp/HeroSectionBox.jsx';
import MenuSection from './custom-comp/MenuSection.jsx';
import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import axios from 'axios';
import FooterTagSection from './custom-comp/FooterTagSection.js';
import Package from './custom-comp/Package.jsx';


export default function PartyPackageDetailPage() {

  const [data, setData] = useState([]);
  const [clubId, setClubId] = useState("");
  const [events, setEvents] = useState([]);
  const [menus, setMenus] = useState([]);
  const [packageId, setPackageId] = useState("");
  const [otherPackages, setOtherPackages] = useState([]);
  const [otherPackages1, setOtherPackages1] = useState([]);
  const [teasers, setTeasers] = useState([]);


  // const { city, area, club, packageName } = useParams();
  const { packagedetail, title } = useParams();
  const [club, city, area] = packagedetail.split("-").map((str) => str.replace(/_/g, " "));
  const [packageName] = title.split("-").map((str) => str.replace(/_/g, " "));


  const newApi = new FormData();
  newApi.append("city", city);
  newApi.append("area", area);
  newApi.append("club", club);


  // package Details
  useEffect(() => {
    const formdata = new FormData();
    formdata.append("city", city);
    formdata.append("area", area);
    formdata.append("club", club);
    formdata.append("title", packageName);
    axios
      .post("https://partywitty.com/master/APIs/Web/packageDetails", formdata)
      .then((response) => {
        if (response.data.status === "true") {
          setData({});
        } else if (response.data.data && response.data.data.length > 0) {
          setData(response.data.data[0]);
          setPackageId(response.data.data[0].id);
          setClubId(response.data.data[0].club_id);
        } else {
          console.error("No data found in response:", response.data);
        }
      })
      .catch((error) => {
        console.log("Error fetching package details:", error);
      });
  }, [city, area, club, packageName]);

  // get Package Menu
  useEffect(() => {
    const PackageMenu = new FormData();
    PackageMenu.append("package_id", packageId);
    axios
      .post(
        "https://partywitty.com/master/APIs/ClubPackage/getPackageMenu1",
        PackageMenu
      )
      .then((response) => {
        if (response.data.status) {
          setMenus(response.data.data);
        }
      })
      .catch((error) => {
        console.log(error);
      });
  }, [packageId]);

  // package Of Same Club
  useEffect(() => {
    const PackageMenu1 = new FormData();
    PackageMenu1.append("package_id", packageId);
    PackageMenu1.append("club_id", clubId);

    axios
      .post(
        "https://partywitty.com/master/APIs/ClubPackage/packageOfSameClub",
        PackageMenu1
      )
      .then((response) => {
        if (response.data.status === true) {
          setOtherPackages(response.data.data);
        } else {
          console.log("No data found");
        }
      })
      .catch((error) => {
        console.log("Error fetching data: ", error);
      });
  }, [packageId, clubId]);

  // same Package Of Other Club
  useEffect(() => {
    const PackageMenu1 = new FormData();
    PackageMenu1.append("package_id", packageId);
    PackageMenu1.append("club_id", clubId);

    axios
      .post(
        "https://partywitty.com/master/APIs/ClubPackage/samePackageOfOtherClub",
        PackageMenu1
      )
      .then((response) => {
        if (response.data.status === true) {
          setOtherPackages1(response.data.data);
        } else {
          console.log("No data found");
        }
      })
      .catch((error) => {
        console.log("Error fetching data: ", error);
      });
  }, [packageId, clubId]);

  // get Teaser
  useEffect(() => {
    const PackageMenu2 = new FormData();
    PackageMenu2.append("club_id", clubId);

    axios
      .post("https://partywitty.com/master/APIs/Common/getTeaser", PackageMenu2)
      .then((response) => {
        if (response.data.status === true) {
          setTeasers(response.data.data);
        } else {
          PackageMenu2.set("club_id", "Admin");
          axios
            .post(
              "https://partywitty.com/master/APIs/Common/getTeaser",
              PackageMenu2
            )
            .then((response) => {
              if (response.data.status === true) {
                setTeasers(response.data.data);
              } else {
                console.log("No data found for club_id Admin either");
              }
            })
            .catch((error) => {
              console.log("Error fetching data for Admin: ", error);
            });
        }
      })
      .catch((error) => {
        console.log("Error fetching data: ", error);
      });
  }, [clubId]);


  // club Wise All Events
  useEffect(() => {
    const PackageMenu2 = new FormData();
    PackageMenu2.append("club_id", clubId);

    const fetchEvents = async () => {
      try {
        const response = await axios.post("https://partywitty.com/master/APIs/ClubEvent/clubWiseAllEvents", PackageMenu2
        );

        if (response.data.status && response.data.data) {
          setEvents(response.data.data);
        } else {
          setEvents([]);
        }
      } catch (error) {
        console.error("Error fetching events:", error);
        setEvents([]);
      }
    };

    fetchEvents();
  }, [clubId]);



  const generateRelatedLinks = (club, city, area) => {
    // Capitalize first letter of each word
    const format = (str) =>
      str?.toLowerCase()
        .replace(/_/g, " ")
        .replace(/\b\w/g, (c) => c.toUpperCase());

    const formattedCity = format(city).replace(" ", "-");      // Noida
    const formattedArea = format(area);      // Sector 38
    const formattedClub = format(club);  // F Bar

    return [
      {
        id: 1,
        url: `/venues/${formattedCity}`,
        tag: `Party Packages in ${formattedCity}`,
      },
      {
        id: 2,
        url: `/venues/${formattedCity}`,
        tag: formattedCity,
      },
      {
        id: 3,
        url: `/venues/${formattedCity}`,
        tag: `${formattedCity} Party Packages`,
      },
      {
        id: 4,
        url: `/venues/${formattedCity}`,
        tag: `${formattedCity} Party Packages in ${formattedCity}`,
      },
      {
        id: 5,
        tag: `${formattedCity} Packages in ${formattedArea}`,
      },
      {
        id: 6,
        tag: `${formattedCity} ${formattedArea} Party Packages`,
      },
      {
        id: 7,
        tag: `music Dining in ${formattedCity}`,
      },
      {
        id: 8,
        tag: `Party Packages in ${formattedCity}`,
      },
      {
        id: 9,
        tag: `Packges in ${formattedCity}`,
      },
      {
        id: 10,
        tag: `${formattedClub} - ${formattedArea} - ${formattedCity}`,
      },
    ];
  };

  const relatedLinks = generateRelatedLinks(club, city, area);


  return (
    <div className='vcdp-section '>
      <div className='vcdp-container'>
        <HeroSectionBox data={data} isPartyPackege={true} />
         <div className='vcdp-content-container'>
        <MenuSection teasers={teasers} menus={menus} events={events} isPartyPackage={true} />

        <div className='party-package-details-page-recommendation-section'>
          <h1 className='vcdp-recommendation-section-title'>Other Packages from this club</h1>
          <div className='vcdp-recommendation-container'>
            <Package partypackages={otherPackages} isPartyPackage={true} />
          </div>
        </div>
        <div className='party-package-details-page-recommendation-section'>
          <h1 className='vcdp-recommendation-section-title'>Similar Packages from the other clubs</h1>
          <div className='vcdp-recommendation-container'>
            <Package partypackages={otherPackages1} isPartyPackage={true} />
          </div>

        </div>
        <FooterTagSection clubInfo={packagedetail} relatedLinks={relatedLinks} />
        </div>
      </div>
    </div>
  )
}
